import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const ReferenceLineLabelContainer = styled.text`
  display: flex;
  flex-direction: row;
  align-items: center;
  fill: #e44b27;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-weight: 600;
  font-size: 16px;

  .ht {
    fill: black;
    opacity: 0.3;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
  }
`;

const ReferenceLineLabel = ({ viewBox, value, currency }) => (
  <ReferenceLineLabelContainer>
    <tspan x={viewBox.x} y={viewBox.y} dy={-5} textAnchor="middle">
      {value.toLocaleString('fr-FR', {
        style: 'currency',
        currency: currency ? currency : 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
    </tspan>
    <tspan dx={5} className="ht">
      {I18n.t('ht')}
    </tspan>
  </ReferenceLineLabelContainer>
);

export default ReferenceLineLabel;
